<div [formGroup]="form" class="flex items-end gap-3 mb-4 flex-wrap">
  <mat-form-field class="input-tg flex-1" appearance="outline" style="min-width:180px">
    <mat-label>Descrição</mat-label>
    <input matInput formControlName="descricao" />
  </mat-form-field>
  <mat-form-field class="input-tg" appearance="outline" style="width:220px">
    <mat-label>Tipo</mat-label>
    <mat-select formControlName="tipoDocId" [disabled]="loadingTipos || tipoDocOptions.length == 0">
      @for (tipo of tipoDocOptions; track tipo.id) {
        <mat-option [value]="tipo.id">{{ tipo.descricao }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <input hidden type="file" (change)="onFileSelected($event)" #fileInput accept=".pdf,.jpg,.jpeg,.png" />
  <mat-form-field class="input-tg" appearance="outline" style="width:220px">
    <mat-label>Arquivo</mat-label>
    <input matInput formControlName="file" readonly (click)="fileInput.click()" />
    <button mat-icon-button matSuffix type="button" (click)="fileInput.click()">
      <mat-icon>upload</mat-icon>
    </button>
  </mat-form-field>

  <button
    mat-flat-button class="btn-tg"
    type="button"
    [disabled]="form.invalid || uploading || !selectedFile"
    (click)="upload()"
  >
    @if (uploading) {
      <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
    } @else {
      Enviar
    }
  </button>
</div>

@if (!loadingTipos && tipoDocOptions.length == 0) {
  <p class="text-sm text-gray-500 mb-3">
    Nenhum tipo de documento disponível para este cadastro no momento. Fale com o suporte antes de enviar.
  </p>
}

@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
} @else if (documents.length > 0) {
  <div class="tab-overflow">
    <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
      <ng-container matColumnDef="descricao">
        <th mat-header-cell *matHeaderCellDef>Descrição</th>
        <td mat-cell *matCellDef="let doc">{{ doc.descricao }}</td>
      </ng-container>
      <ng-container matColumnDef="nomeArquivo">
        <th mat-header-cell *matHeaderCellDef>Arquivo</th>
        <td mat-cell *matCellDef="let doc">{{ doc.nomeArquivo }}</td>
      </ng-container>
      <ng-container matColumnDef="tipoDocDescricao">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let doc">{{ doc.tipoDocDescricao }}</td>
      </ng-container>
      <ng-container matColumnDef="dataCriacao">
        <th mat-header-cell *matHeaderCellDef>Data</th>
        <td mat-cell *matCellDef="let doc">{{ doc.dataCriacao }}</td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Ações</th>
        <td mat-cell *matCellDef="let doc">
          <div class="flex gap-3 items-center">
            @if (downloadingId == doc.id) {
              <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
            } @else {
              <mat-icon class="btn-icon-outline" fontIcon="download" matTooltip="Baixar" (click)="download(doc)" />
            }
            @if (deletingId == doc.id) {
              <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
            } @else {
              <mat-icon class="btn-icon-outline" fontIcon="delete" matTooltip="Excluir" (click)="confirmDelete(doc)" />
            }
          </div>
        </td>
      </ng-container>
      <tr mat-header-row class="style-header" *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row class="style-row" *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
} @else {
  <p class="text-sm text-gray-500 text-center py-4">Nenhum documento enviado ainda.</p>
}
